<div class="flex flex-row gap-[8px]">
  <img class="device-img" [src]="imagePath.wallbox3rdPartImagePath" />
  <div class="flex flex-col">
    <span *ngIf="deviceName$ | async as deviceName" class="tile-title">
      {{ deviceName }}
    </span>
    <div class="serial-container">
      <span *ngIf="deviceModel$ | async as deviceModel" class="serial">
        <!-- Ignore dash from value2 -->
        {{ deviceModel?.properties?.value?.value }}
      </span>
    </div>
  </div>
</div>
